module.exports = __webpack_public_path__ + "static/img/bg-index.84d9f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingyun-kucun/bg-index.jpg
// module id = tgGZ
// module chunks = 1